import { ChassisType, ChassisModelTypes, ChassisPassengerCapacities, ChassisSeriesTypes } from "../../../../../@types/ChassisType";
import assets from "../../../../../assets";

// X6 Specific Products
import { ChassisBatteryConfigs, ChassisBatteryConfigsPreassembly } from "./X6Products/ChassisBatteryConfigs";
import SeatFrames from "./X6Products/SeatFrames";
import Tops from "./X6Products/Tops";

// Shared Products between XSeries Chassis
import { BodyColorsX6 } from "../Shared/BodyColors";
import { LiftKitsX6 } from "../Shared/LiftKit";
import Batteries from "../Shared/Batteries";
import { 
    Wheels12InLifted, 
    Wheels12In,
    Wheels14InLifted, 
    Wheels14In, 
    Wheels15In, 
    WheelSizeOptions 
} from "./X6Products/Wheels";
import LugNuts from "../../Shared/LugNuts";
import { 
    Tires12In, 
    Tires12InLifted, 
    Tires14In, 
    Tires14InLifted, 
    Tires15In, 
    Tires15InLifted 
} from "../Shared/Tires";
import { 
    ColoradoDesignSolidFrontSeatsX6, 
    ColoradoDesignSolidRearSeatsX6 
} from "../Shared/Seats";
import { AccessoriesXSeries, AccessoriesXSeriesLifted, AccessoriesXSeriesOptional, AccessoriesXSeriesOptionalLifted, AccessoriesXSeriesOptionalNonLifted } from "../../Shared/Accessories";
import { LsvKit, LsvKitPreassembled } from "./X6Products/LsvKits";
import WindShields from "../Shared/WindShields";

export const X6: ChassisType = {
    id: `${ChassisModelTypes.X6}-2025`,
    sku: `${ChassisModelTypes.X6}-2025`,
    series: ChassisSeriesTypes.ESeries,
    categoryName: 'XSeries',
    name: '2025 XSeries X6 6 Passenger',
    year: 2025,
    model: ChassisModelTypes.X6,
    logo: assets.images.chassisLogo.x6,
    passengerCapacity: ChassisPassengerCapacities["6 Passenger"],
    price: 9465,
    retailPrice: 15495,
    marketingSlogan: 
    `More Features. More Family. More Fun.`,
    bodyColorOptions: BodyColorsX6,
    liftKitOptions: LiftKitsX6,
    chassisBatteryConfigOptions: ChassisBatteryConfigs,
    chassisBatteryOptions: Batteries,
    wheelSizeOptions: WheelSizeOptions,
    wheelOptions: [
        ...Wheels12In,
        ...Wheels14In
    ],
    wheelOptionsLifted: [
        ...Wheels12InLifted,
        ...Wheels14InLifted,
        ...Wheels15In
    ],
    lugNutOptions: LugNuts,
    tireOptions: [
        ...Tires12In,
        ...Tires14In,
        ...Tires15In
    ],
    tireOptionsLifted: [
        ...Tires12InLifted,
        ...Tires14InLifted,
        ...Tires15InLifted
    ],
    lsvKitOptions: LsvKit,
    topOptions: Tops,
    windshieldOptions: WindShields,
    frontSeatOptions: ColoradoDesignSolidFrontSeatsX6,
    middleSeatOptions: ColoradoDesignSolidFrontSeatsX6,
    rearSeatOptions: ColoradoDesignSolidRearSeatsX6,
    seatFrameOptions: SeatFrames,
    preassembled: false,
    allowInternationalPurchase: false,
    includedAccessories: AccessoriesXSeries,
    includedAccessoriesLifted: AccessoriesXSeriesLifted,
    optionalAccessories: [...AccessoriesXSeriesOptional, ...AccessoriesXSeriesOptionalNonLifted],
    optionalAccessoriesLifted: AccessoriesXSeriesOptionalLifted
}

export const X6Assy: ChassisType = {
    ...X6,
    id: `${ChassisModelTypes.X6}-2025-Assy`,
    sku: `${ChassisModelTypes.X6}-2025-Assy`,
    price: 9765,
    preassembled: true,
    allowInternationalPurchase: true,
    lsvKitOptions: LsvKitPreassembled,
    chassisBatteryConfigOptions: ChassisBatteryConfigsPreassembly
};